<template>
  <div class="bargain-active-index">
    <!--搜索表单-->
     <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick">添加体验者</el-button>
    </div>


    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="user_name" label="姓名"></el-table-column>
          <el-table-column prop="wechatid" label="wechatid"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="deleteClick(scope.row.port_tester_id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>

      <Add :open="open_add" :port_id="port_id" @close="closeAdd"></Add>
    </div>
  </div>
</template>
<script>
import PortApi from '@/api/port.js';
import Add from './dialog/Add.vue';
export default {
   components: {
    Add
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*搜索表单对象*/
      searchForm: {},
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*是否打开添加弹窗*/
      open_add: false,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1
    };
  },
  created() {
    this.type = this.$route.query.type;
    this.port_id = this.$route.query.port_id;
    console.log(this.port_id);
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.port_id = self.port_id;
      self.loading = true;
      PortApi.testerList(Params, true)
        .then(res => {
          self.loading = false;
          self.tableData = res.data.list.data;
          self.totalDataNumber = res.data.list.total;
        })
        .catch(error => {});
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*打开添加*/
    addClick() {
      if(!this.role_loading){
         this.open_add=true;
      }
    },

    /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      if(e.type=='success'){
        this.getTableList();
      }
    },

    /*添加体验者*/
    addTester() {
      let self = this;
      let Params = self.searchForm;
      PortApi.addTester(Params, true)
        .then(res => {
          self.loading = false;
          self.tableData = res.data.list.data;
          self.totalDataNumber = res.data.list.total;
        })
        .catch(error => {});
    },

    /*删除体验者*/
    deleteClick(e) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          PortApi.deleteTester(
            {
              port_tester_id: e
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getData();
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/port/testermanager/index.vue